import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";

import { useLanguage } from "@hooks/useLanguage";
import { IconTrash01 } from "@pentabd/icons";

export const ProductsTableColumn = (
  t: TFunction<"translation", undefined>,
  handleProductsRemove: (id: number | string) => void,
) => {
  const { language } = useLanguage();
  return [
    {
      id: 1,
      key: "category",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_DETAILS.PRODUCT_TABLE.COLUMN.CATEGORY",
      ),
      render: (category: string, row: any) => {
        return (
          <Text color="subtitle1">{category ? category : "..."}55555555</Text>
        );
      },
    },
    {
      id: 2,
      key: "group",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_DETAILS.PRODUCT_TABLE.COLUMN.GROUP",
      ),
      render: (group: string, row: any) => {
        return <Text color="subtitle1">{group ? group : "..."}</Text>;
      },
    },
    {
      id: 2,
      key: "type",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_DETAILS.PRODUCT_TABLE.COLUMN.TYPE",
      ),
      render: (type: string, row: any) => {
        return <Text color="subtitle1">{type ? type : "..."}</Text>;
      },
    },
    {
      id: 4,
      key: "nameEn",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_DETAILS.PRODUCT_TABLE.COLUMN.NAME",
      ),
      render: (nameEn: string, row: any) => {
        const name = language === "en" ? row?.nameEn : row?.nameBn;
        return <Text color="subtitle1">{name ? name : "..."}</Text>;
      },
    },
    {
      id: 5,
      key: "brand",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_DETAILS.PRODUCT_TABLE.COLUMN.BRAND",
      ),
      render: (brand: string, row: any) => {
        return <Text color="subtitle1">{brand ? brand : "..."}</Text>;
      },
    },
    {
      id: 6,
      key: "lotNo",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_DETAILS.PRODUCT_TABLE.COLUMN.LOT_NUMBER",
      ),
      render: (lotNo: number, row: any) => {
        return <Text color="subtitle1">{lotNo ? lotNo : "..."}</Text>;
      },
    },
    {
      id: 7,
      key: "serialNo",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_DETAILS.PRODUCT_TABLE.COLUMN.SERIAL_NUMBER",
      ),
      render: (serialNo: string | number) => {
        return <Text color="subtitle1">{serialNo ? serialNo : "..."}</Text>;
      },
    },
    {
      id: 8,
      key: "barcode",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_DETAILS.PRODUCT_TABLE.COLUMN.BARCODE",
      ),
      render: (barcode: string | number) => {
        return <Text color="subtitle1">{barcode ? barcode : "..."}</Text>;
      },
    },
    {
      id: 9,
      key: "assignAmount",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_DETAILS.PRODUCT_TABLE.COLUMN.ASSIGN_AMOUNT",
      ),
      render: (assignAmount: number) => {
        return (
          <Text color="subtitle1">{assignAmount ? assignAmount : "..."}</Text>
        );
      },
    },
    {
      id: 10,
      key: "id",
      name: "",
      render: (id: number | string) => {
        return (
          <div
            onClick={() => {
              handleProductsRemove(id);
            }}
            className="cursor-pointer"
          >
            <IconTrash01 size={24} fill="danger" />
          </div>
        );
      },
    },
  ];
};
